import {Component, HostListener, Input} from '@angular/core';
import {NgIf} from "@angular/common";
import {animate, state, style, transition, trigger} from "@angular/animations";

@Component({
  selector: 'app-custom-tooltip',
  standalone: true,
  imports: [
    NgIf
  ],
  templateUrl: './custom-tooltip.component.html',
  styleUrl: './custom-tooltip.component.scss',
})
export class CustomTooltipComponent {
  @Input() title: string = '';
  @Input() description: string = '';

  isVisible: boolean = false;

  @HostListener('mouseenter') onMouseEnter() {
    this.isVisible = true;
  }

  @HostListener('mouseleave') onMouseLeave() {
    this.isVisible = false;
  }
}
